import BaseStore from '@/store/BaseStore'
import { Module, Mutation } from '@/node_modules/vuex-module-decorators'
import { BibliographySetDetailVolume } from '@/api'

@Module({
  name: 'BibliographyDetailSetStore',
  namespaced: true,
  stateFactory: true
})
// 現状、資料（雑誌・誌名）の巻次のペジネーションのみに使用している
// もし、上記処理をstoreで行う必要が無くなれば削除しても構わない
export default class BibliographyDetailSetStore extends BaseStore {
  _volumes: BibliographySetDetailVolume[] = []

  get volumes(): BibliographySetDetailVolume[] {
    return this._volumes
  }

  @Mutation
  public reset() {
    this._volumes = []
  }

  @Mutation
  public setVolumes(value: BibliographySetDetailVolume[]) {
    this._volumes = value
  }
}
